import { render, staticRenderFns } from "./CourseWork.vue?vue&type=template&id=4c3b7199&scoped=true&"
import script from "./CourseWork.vue?vue&type=script&lang=js&"
export * from "./CourseWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3b7199",
  null
  
)

export default component.exports